export type AuthErrorKind = 'unreachable' | 'accessDenied' | 'tokenVersion' | 'sessionExpired' | 'serviceUnavailable' | 'cancelled' | 'unknown';

export class AuthError extends Error {
    constructor(public readonly kind: AuthErrorKind) {
        super(`Entra sign-in failed: ${kind}`);
        this.name = 'AuthError';
    }
}

export const authErrorKind = (err: unknown): AuthErrorKind => (err instanceof AuthError ? err.kind : 'unknown');

/** App role the client's IT assigns to the users allowed into the Client App. */
export const ENTRA_USER_ROLE = 'Privanot.User';
